import React from 'react';

import { Text } from '@thefarmersfront/kitchen';

/**
 * [입고관리 > 입고요청관리] 요청상태가 [요청취소]인 상태 포함 후, 검수확인용 거래명세서 다운로드 시의 다이알로그
 */
const DialogCanceledStatusIncludedSpecifications = () => {
  return (
    <Text element="span" size="large">
      <Text element="span" size="large" weight="semi-bold">
        [요청취소]{' '}
      </Text>
      상태의 요청이 선택되어 있습니다.
      <Text element="p" size="large">
        나머지 선택 항목의 거래명세서를 다운로드 받으시겠습니까?
      </Text>
    </Text>
  );
};

export default DialogCanceledStatusIncludedSpecifications;
